import { useEffect, useState } from 'react'

export const useIsMounted = function () {
  const [componentIsMounted, setComponentIsMounted] = useState(true)

  useEffect(
    () =>
      function () {
        setComponentIsMounted(false)
      },
    []
  )

  return componentIsMounted
}
